import { typography } from '../main.css.ts'
import * as styles from './footer.css.ts'

export const Footer = () => (
  <footer className={styles.footer}>
    <p className={styles.footerTradeMark}>
      <span className={typography.smallBold}>© {new Date().getFullYear()} Pixee Inc.</span> All rights reserved
    </p>
    <ul className={styles.footerLinksList}>
      <li>
        <a href="https://www.pixee.ai/terms" target="_blank" className={styles.footerLink}>
          Terms of Service
        </a>
      </li>
      <li>
        <a href="https://www.pixee.ai/privacy" target="_blank" className={styles.footerLink}>
          Privacy Policy
        </a>
      </li>
      <li>
        <a href="mailto:feedback@pixee.ai" target="_blank" className={styles.footerLink}>
          Contact Us
        </a>
      </li>
    </ul>
  </footer>
)
